import styled, { css, type DefaultTheme, keyframes } from 'styled-components'
import { ErrorMessage } from '@velasca/ui/error-message'
import { InfoButton } from '@velasca/ui/info-button'
import { SizesGroup } from '@velasca/ui/sizes-group'

const blinkAnimation = ({ theme }: { theme: DefaultTheme }) => keyframes`
  50% {
    background-color: ${theme.colors.primaryLight}40; 
  }
`

export const StyledSizesGroup = styled(SizesGroup)<{
  $isGiftCard: boolean
}>`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  column-gap: ${({ $isGiftCard }) => ($isGiftCard ? '2rem' : '1rem')};
  row-gap: ${({ $isGiftCard }) => ($isGiftCard ? '1.4rem' : '1rem')};
`

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

export const WrapperSizePicker = styled.div<{ isBlinking: boolean }>`
  gap: 1rem;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 2rem;
  justify-content: center;
  align-items: center;
  background-color: #fff;

  ${({ isBlinking }) =>
    isBlinking &&
    css`
      animation: ${blinkAnimation} 0.5s ease-in 0.7s;
    `}

  @media (min-width: 992px) {
    border-radius: 0.8rem;
  }
`

export const WrapText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1rem 0 1.5rem 0;
  width: 100%;
`

export const Footer = styled.div`
  margin: 1rem 0;
`

export const Hr = styled.hr`
  border-top-color: ${({ theme }) => theme.colors.disabled};
  margin: 0;
`

export const SizeGuideButton = styled.div`
  cursor: pointer;
`

export const AddToCart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const AddToCartButtonWrapper = styled.div`
  margin-top: 1rem;
  width: 100%;

  @media screen and (min-width: 370px) {
    max-width: 32rem;
  }
`

export const StyledErrorMessage = styled(ErrorMessage)`
  margin: 1rem auto;
  text-align: center;
  max-width: 32rem;
`

// TODO: SHOP-3680
// This component with specific z-index is needed to avoid the tooltip to be
// hidden behind <main> element on woman, because it has a z-index not present
// on men. This is a temporary solution, we should remove it after all product
// pages will be migrated to new teplates.
export const StyledInfoButton = styled(InfoButton)`
  z-index: 1;
`
